import { DataSourcesView } from "../components/library/DataSourcesView";

/* Admin → Datasets — moved out of the cockpit tab bar. Designers
 * and clients shouldn't see Kaggle citations / dataset internals
 * in their day-to-day surface; the admin can audit them here. */

export default function AdminDatasets(): JSX.Element {
  return (
    <div className="max-w-[1280px] mx-auto px-4 sm:px-8 py-10">
      <header className="mb-6">
        <div className="eyebrow">Admin · datasets</div>
        <h1 className="display-2 mt-1 text-ink-950">Where the ontology came from.</h1>
        <p className="text-[13px] text-ink-500 mt-1 max-w-3xl">
          The 10 verified Kaggle datasets that shaped the typed schema. Auditable, citable,
          re-ingestable. Studio designers don't see this surface — only admins do.
        </p>
      </header>
      <DataSourcesView />
    </div>
  );
}
